module.exports = __webpack_public_path__ + "static/media/basic_resume_button.0d7f4c4b.webp";